export const DRIVETRAIN_SECTION_ID = 'drivetrain';
export const ENGINE_SECTION_ID = 'engine';
export const EXTERIOR_COLOR_SECTION_ID = 'exterior-color';
export const INTERIOR_COLOR_SECTION_ID = 'interior-color';
export const PACKAGES_SECTION_ID = 'packages-section';
